import React, { useEffect } from "react";
import firstimg from '../assets/images/imgs/fst-screen-img.jpg'
import aboutUs from '../assets/images/bgimgs/About us 2 -1.jpg'
import aboutUs2 from '../assets/images/bgimgs/About us 2 -2.jpg'
import about4 from '../assets/images/bgimgs/about us 4 -1.jpg'
import about42 from '../assets/images/bgimgs/about us 4 -2.jpg'
import about5 from '../assets/images/imgs/About us 5 copy.jpg'
import drwalid from '../assets/images/imgs/dr.jpeg'
import drwalid2 from '../assets/images/bgimgs/Dr waled 2.jpg'
import jitu from '../assets/images/bgimgs/Lorraine1.jpg'
import jitu2 from '../assets/images/bgimgs/Lorraine2.jpg'
import sobby1 from '../assets/images/bgimgs/Sobby1.jpg'
import sobby2 from '../assets/images/bgimgs/Sobby2.jpg'
import sagar from '../assets/images/imgs/sagar.jpeg'
import sagar2 from '../assets/images/bgimgs/Sagar 2.jpg'
import anhilina from '../assets/images/imgs/anhilina.jpeg'
import anhilina2 from '../assets/images/bgimgs/anhelina 2.jpg'
import maher from '../assets/images/imgs/salesmanager.JPG'
import maher2 from '../assets/images/bgimgs/Maher 2.jpg'
import prakash from '../assets/images/imgs/financemanager.JPG'
import prakash2 from '../assets/images/bgimgs/Prakash 2.jpg'
import bilal from '../assets/images/bgimgs/Bilal 1.jpg'
import bilal2 from '../assets/images/bgimgs/Bilal 2.jpg'
import { Link } from "react-router-dom";
import iso from '../assets/images/imgs/ISO.png'
import haccap from '../assets/images/imgs/HACCP.png'
import ghp from '../assets/images/imgs/GHP.png'
import { useTranslation } from 'react-i18next';
import hf from '../assets/haccpc.pdf'
import isof from '../assets/iso.pdf'
import ghpf from '../assets/haccp.pdf'


export default function About() {
    const { t } = useTranslation();

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('home');
    }, [])
    return (
        <div id="content">
            <section className="min-h-[calc(100vh-100px)] pb-[100px] py-[50px] lg:py-[10px] flex flex-col lg:flex-row px-[10px] lg:px-[50px] xl:px-[100px] gap-[50px] justify-center items-center">
                <div className="flex justify-center flex-col gap-[50px]">
                    <h1 className="is-slideup flex flex-col text-3xl md:text-2xl lg:text-4xl xl:text-6xl font-black nc w-content w-full lg:w-[600px]">
                        <span className="pl-[50px] uppercase">{t('igt_brand')}</span>
                        <span className="font-thin text-[#9794AF] uppercase">{t('unmatched')}</span>
                        <span className="font-thin text-[#9794AF] uppercase text-end"> {t('igt_unmatched')} </span>
                        <span className="uppercase text-end"> {t('intheuae')} </span>
                    </h1>
                    <h2 className="nc text-lg lg:text-2xl capitalize max-w-[600px]">
                        {t('delivering_quality')}
                    </h2>
                </div>
                <div className="min-w-full lg:min-w-[500px]">
                    <img src={firstimg} className="w-full lg:w-[600px]" alt="" />
                </div>
            </section>

            <section className="h-[100px]"></section>

            <section className="min-h-[80vh] py-[50px] lg:py-[10px] px-[10px] lg:px-[100px] gap-[20px] flex flex-col lg:flex-row justify-evenly items-center">
                <div className="max-w-[600px] lg:max-w-[800px] flex flex-col nc gap-[50px] p-[10px] lg:p-[50px]">
                    <h1 className="is-slideup text-2xl xl:text-4xl 2xl:text-6xl font-black">{t('our_story')}</h1>
                    <h2 className="text-lg lg:text-xl xl:text-2xl 2xl:text-3xl text-start capitalize">{t('story_desc')}</h2>
                </div>
                <div className="min-w-full lg:min-w-[500px] pe-[0px] lg:pe-[50px] group">
                    <img className="w-full lg:w-[500px] group-hover:hidden" src={aboutUs} alt="" />
                    <img className="w-full lg:w-[500px] hidden group-hover:block" src={aboutUs2} alt="" />
                </div>
            </section>

            <section className="h-[100px]"></section>

            <section className="advantages-section p-[10px] lg:p-[50px] py-[50px] lg:py-[150px] xl:p-[100px] py-[100px] h-screen relative">
                <div className="w-full md:w-lg  font-black mb-[50px] lg:mb-[100px] mt-[50px]" >
                    <h2 className="is-slideup text-lg md:text-lg lg:text-5xl 2xl:text-6xl nc capitalize">
                        {t('journey_growth')}
                    </h2>
                </div>
                <div className="absolute top-[480px] lg:top-[550px] 2xl:top-[570px] w-screen h-[2px] left-[0px] nbg"></div>
                <div className="pl-[50%]">
                    <ol className="flex items-center gap-[30px] relative left-[10%] my-[100px] snap-x snap-mandatory scroll-smooth w-full px[0px]">
                        <li className="flex flex-col advantage snap-start w-screen md:w-[600px] h-[350px] shrink-0 p-[20px]">
                            <span className="flex gap-[20px]">
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl text-[#D0A847] font-semibold">{t('birth')}</h2>
                            </span>
                            <h2 className="text-md md:text-md lg:text-lg xl:text-xl 2xl:text:3xl pt-[20px] font-thin nc capitalize">{t('birth_desc')}</h2>
                            <span className="flex-1 flex"></span>
                            <h2 className="text-[#D0A847] text-6xl" style={{ fontFamily: t('time_new_roman') }}>{t('year_2010')}</h2>
                        </li>
                        <li className="flex flex-col advantage snap-start w-screen md:w-[600px] h-[350px] shrink-0 p-[20px]">
                            <span className="flex gap-[20px]">
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl text-[#D0A847] font-semibold">{t('formation')}</h2>
                            </span>
                            <h2 className="text-md md:text-md lg:text-lg xl:text-xl 2xl:text:3xl pt-[20px] font-thin nc capitalize">{t('formation_desc')}</h2>
                            <span className="flex-1 flex"></span>
                            <h2 className="text-[#D0A847] text-6xl" style={{ fontFamily: t('time_new_roman') }}>{t('year_2011')}</h2>
                        </li>
                        <li className="flex flex-col advantage snap-start w-screen md:w-[600px] h-[350px] shrink-0 p-[20px]">
                            <span className="flex gap-[20px]">
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl text-[#D0A847] font-semibold">{t('expansion')}</h2>
                            </span>
                            <h2 className="text-md md:text-lg lg:text-lg xl:text-xl 2xl:text:3xl pt-[20px] font-thin nc capitalize">{t('expansion_desc')}</h2>
                            <span className="flex-1 flex"></span>
                            <h2 className="text-[#D0A847] text-6xl" style={{ fontFamily: t('time_new_roman') }}>{t('year_2013_2016')}</h2>
                        </li>
                        <li className="flex flex-col advantage snap-start w-screen md:w-[600px] h-[350px] shrink-0 p-[20px]">
                            <span className="flex gap-[20px]">
                                <h2 className="text-lg md:text-xl lg:text:2xl 2xl:text-4xl text-[#D0A847] font-semibold">{t('leap_forward')}</h2>
                            </span>
                            <h2 className="text-md md:text-md lg:text-lg xl:text-xl 2xl:text:3xl pt-[20px] font-thin nc capitalize">{t('leap_forward_desc')}</h2>
                            <span className="flex-1 flex"></span>
                            <h2 className="text-[#D0A847] text-6xl" style={{ fontFamily: t('time_new_roman') }}>{t('year_2017_2022')}</h2>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="h-[100px]"></section>

            <section className="min-h-[80vh] py-[50px] lg:py-[10px] px-[10px] lg:px-[100px] gap-[20px] flex flex-col lg:flex-row justify-evenly items-center">
                <div className="max-w-[600px] lg:max-w-[800px] flex flex-col nc gap-[50px] p-[10px] lg:p-[50px]">
                    <h1 className="is-slideup text-3xl xl:text-5xl 2xl:text-7xl font-black">{t('igt_secret')}</h1>
                    <h2 className="text-lg lg:text-xl xl:text-2xl 2xl:text-3xl text-start capitalize">{t('secret_desc')}</h2>
                </div>
                <div className="min-w-full lg:min-w-[400px] 2xl:min-w-[500px] pe-[0px] lg:pe-[50px] group max-h-[calc(100vh-200px)] overflow-hidden">
                    <img className="w-full lg:w-[400px] 2xl:min-w-[500px] group-hover:hidden" src={about4} alt="" />
                    <img className="w-full lg:w-[400px] 2xl:min-w-[500px] hidden group-hover:block" src={about42} alt="" />
                </div>
            </section>

            <section className="h-[100px]"></section>

            <section className="min-h-[80vh] py-[50px] lg:py-[10px] px-[10px] lg:px-[100px] gap-[20px] flex flex-col lg:flex-row justify-evenly items-center">
                <div className="max-w-[600px] lg:max-w-[800px] flex flex-col nc gap-[10px] p-[10px] lg:p-[50px]">
                    <h1 className="is-slideup text-xl xl:text-2xl 2xl:text-4xl font-black">{t('chairman_message')}</h1>
                    <h2 className="text-lg  xl:text-lg text-start capitalize">{t('chairman_desc1')}</h2>
                    <h2 className="text-lg  xl:text-lg text-start capitalize">{t('chairman_desc2')}</h2>
                    <h2 className="text-lg  xl:text-lg text-start capitalize">{t('chairman_desc3')}</h2>
                    <div className="flex flex-col items-end">
                        <h2 className="text-start w-[150px] font-black">{t('walid_elsisi')}</h2>
                        <h2 className="text-start w-[150px] text-[#D0A847]">{t('founder_chairman')}</h2>
                    </div>
                </div>
                <div className="min-w-full lg:min-w-[400px] 2xl:min-w-[500px] pe-[0px] lg:pe-[50px] group">
                    <img className="w-full lg:w-[400px] 2xl:min-w-[500px]" src={about5} alt="" />
                </div>
            </section>

            <section className="py-[100px]">
                <div className="nc flex flex-col px-[20px] lg:px-[50px] 2xl:px-[100px] gap-[20px]">
                    <h1 className="is-slideup text-3xl lg:text-5xl 2xl:text-6xl text-center">{t('seamless_operations')}</h1>
                    <h2 className="text-md lg:text-xl 2xl:text-2xl text-start lg:text-center px-[20px] lg:px-[50px]">{t('expert_teams_desc')}</h2>

                    <div className="flex flex-col xl:flex-row justify-center items-center gap-[30px]">
                        <div className="w-full lg:w-[350px] min-w-[300px] group">
                            <img className="block w-full lg:w-[350px] group-hover:hidden" src={drwalid} alt="" />
                            <img className="block w-full lg:w-[350px] hidden group-hover:block" src={drwalid2} alt="" />
                            <h2 className="text-xl font-black">{t('dr_waleed')}</h2>
                            <h3 className="text-sm font-thin">{t('chairman')}</h3>
                        </div>
                        <div className="flex flex-col gap-[20px]">
                            <div className="flex flex-col lg:flex-row gap-[50px] justify-center px-[20px] lg:px-[50px] 2xl:px-[100px]">
                                <div className="w-full lg:w-[250px] group">
                                    <img className="block w-full lg:w-[250px] group-hover:hidden" src={jitu} alt="" />
                                    <img className="block w-full lg:w-[250px] hidden group-hover:block" src={jitu2} alt="" />
                                    <h2 className="text-xl font-black">{t('jittu_george')}</h2>
                                    <h3 className="text-sm font-thin">{t('hc_admin_manager')}</h3>
                                </div>
                                <div className="w-full lg:w-[250px] group">
                                    <img className="block w-full lg:w-[250px] group-hover:hidden" src={maher} alt="" />
                                    <img className="block w-full lg:w-[250px] hidden group-hover:block" src={maher2} alt="" />
                                    <h2 className="text-xl font-black">{t('maher_abdul')}</h2>
                                    <h3 className="text-sm font-thin">{t('head_sales')}</h3>
                                </div>
                                <div className="w-full lg:w-[250px] group">
                                    <img className="block w-full lg:w-[250px] group-hover:hidden" src={sagar} alt="" />
                                    <img className="block w-full lg:w-[250px] hidden group-hover:block" src={sagar2} alt="" />
                                    <h2 className="text-xl font-black">{t('ca_sagar')}</h2>
                                    <h3 className="text-sm font-thin">{t('finance_accounting')}</h3>
                                </div>
                            </div>
                            <div className="flex flex-col lg:flex-row gap-[15px] justify-center px-[20px] lg:px-[50px] 2xl:px-[100px]">
                                {/* <div className="w-full lg:w-[200px] group">
                                    <img className="block w-full lg:w-[200px] group-hover:hidden" src={prakash} alt="" />
                                    <img className="block w-full lg:w-[200px] hidden group-hover:block" src={prakash2} alt="" />
                                    <h2 className="text-xl font-black">{t('prakash_chotia')}</h2>
                                    <h3 className="text-sm font-thin">{t('finance_accounting')}</h3>
                                </div> */}
                                <div className="w-full lg:w-[250px] group">
                                    <img className="block w-full lg:w-[250px] group-hover:hidden" src={anhilina} alt="" />
                                    <img className="block w-full lg:w-[250px] hidden group-hover:block" src={anhilina2} alt="" />
                                    <h2 className="text-xl font-black">{t('anhelina')}</h2>
                                    <h3 className="text-sm font-thin">{t('trade_marketing')}</h3>
                                </div>
                                <div className="w-full lg:w-[250px] group">
                                    <img className="block w-full lg:w-[250px] group-hover:hidden" src={bilal} alt="" />
                                    <img className="block w-full lg:w-[250px] hidden group-hover:block" src={bilal2} alt="" />
                                    <h2 className="text-xl font-black">{t('muhammed_bilal')}</h2>
                                    <h3 className="text-sm font-thin">{t('it_data')}</h3>
                                </div>
                                {/* <div className="w-full lg:w-[200px] group">
                                    <img className="block w-full lg:w-[200px] group-hover:hidden" src={sobby1} alt="" />
                                    <img className="block w-full lg:w-[200px] hidden group-hover:block" src={sobby2} alt="" />
                                    <h2 className="text-xl font-black">{t('sobby')}</h2>
                                    <h3 className="text-sm font-thin">{t('scm')}</h3>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="flex flex-wrap p-[10px] lg:p-[10px] gap-[50px] justify-center">
                    <div className="w-full xl:w-1/4 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[15px] nc">
                        <h2>{t('number_01')}</h2>
                        <span className="flex flex-col gap-[10px]">
                            <h2 className="font-black text-lg">{t('commitment_food')}</h2>
                            <h3>{t('food_safety_desc')}</h3>
                        </span>
                    </div>
                    <div className="w-full xl:w-1/4 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[15px] nc">
                        <h2>{t('number_02')}</h2>
                        <span className="flex flex-col gap-[10px]">
                            <h2 className="font-black text-lg">{t('certified_excellence')}</h2>
                            <h3>{t('excellence_desc')}</h3>
                        </span>
                    </div>
                    <div className="w-full xl:w-1/4 gap-[5px] flex border-[.5px] border-[#D0A847] rounded-[30px] p-[15px] nc">
                        <h2>{t('number_03')}</h2>
                        <span className="flex flex-col gap-[10px]">
                            <h2 className="font-black text-lg">{t('certified_sharjah')}</h2>
                            <h3>{t('sharjah_desc')}</h3>
                        </span>
                    </div>
                </div>
            </section>

            <section className="flex flex-col items-center justify-center p-[10px] lg:p-[100px] gap-[100px] nc">
                <div className="flex flex-col items-center justify-center gap-[50px]">
                    <h1 className="is-slideup text-xl lg:text-3xl 2xl:text-6xl font-black capitalize">{t('igt_certifications')}</h1>
                    <div className="flex gap-[20px]">
                        <a href={isof} target="_blank">
                            <img className="w-[100px] lg:w-[250px] h-[100px] lg:h-[250px]" src={iso} alt={t('iso_alt')} />
                        </a>
                        <a href={hf} target="_blank">
                            <img className="w-[100px] lg:w-[250px] h-[100px] lg:h-[250px]" src={haccap} alt={t('haccp_alt')} />
                        </a>
                        <a href={ghpf} target="_blank">
                            <img className="w-[100px] lg:w-[250px] h-[100px] lg:h-[250px]" src={ghp} alt={t('ghp_alt')} />
                        </a>
                    </div>
                    <h2 className="text-lg lg:text-xl 2xl:text-3xl capitalize text-justify">{t('join_newsletter')}</h2>
                </div>
                <Link to='/contact' className="text-white underline underline-offset-[5px] nbg p-[8px] rounded-full px-[20px] text-lg hover:bg-[#D0A847] hover:text-[#201B57] transition-all duration-[.3s]">{t('sign_up')}</Link>
            </section>
        </div>
    )
}